module.exports = __webpack_public_path__ + "static/media/fred2.0cfd06c7.webp";